import { 
    Chip,
    Divider,
    Grid 
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import Acceso from './Complementos/Acceso';


const Accesos = ({idUser, data, handleUpdateAcceso, enqueueSnackbar})=>{
    const [ getModulos, setModulos ] = useState([]);
    const [ getSecciones, setSecciones ] = useState([]);

    useEffect(()=>{
        (async ()=>{
            const getInfo = await fetch( '/api/Modulos' );
            const jsnInfo = await getInfo.json();
            const Secciones = new Set(jsnInfo.map(el=>el.Seccion));
            const Secciones_ = [...Secciones];
            setSecciones(Secciones_);
            if(data?.length > 0){
                const resInfo = jsnInfo.map((el)=>{
                    const objeto = {...el};
                    const filtrado = data.filter(el2=> el2.Modulo === el.Modulo )
                    if(filtrado.length > 0 ){
                        return filtrado[0];
                    }else{
                        objeto.isActive =  false;
                        return objeto;
                    }
                });

                setModulos( resInfo );
                
            }else{
                setModulos( jsnInfo );
            }
            
        })();
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Grid container justifyContent="center" spacing={2}>
            {
                getSecciones.map((el, index)=>
                    (
                        <React.Fragment key={`Seccion_Acceso_${index}`}>
                            <Grid item xs={12}>
                                <Grid container justifyContent='center' spacing={1}>
                                    <Grid item xs ={12}>
                                        <Chip label={el} color='primary' />
                                    </Grid>
                                    <Grid item xs ={12}>
                                        <Grid container justifyContent='flex-start'>
                                        {
                                            getModulos.map( (el2, index2) => el2.Seccion === el ? 
                                            <Acceso 
                                                {...el2} 
                                                key={`Acceso_${index2}_${index}`} 
                                                idUser={idUser} 
                                                handleUpdateAcceso={handleUpdateAcceso} 
                                                enqueueSnackbar={enqueueSnackbar}
                                            /> : null ) 
                                        }
                                        </Grid>
                                    </Grid>
                                
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                        </React.Fragment>
                    )
                )
            }    
        </Grid>
    );
};



export default Accesos;